import { useMemo } from 'react'

import { MyOptionType } from '@procsea/design-system'

import { useCurrentVertical } from 'src/hooks'
import { useRecursiveRequestableProductsQuery } from 'src/queries/seller/requestableProducts'
import { RequestableProduct } from 'src/types'

export interface RequestableProductOptionType
  extends MyOptionType<MyOptionType<RequestableProduct>> {
  latinName: string
}

interface RequestableProductOptionsProps {
  categoryId?: Id
  verticalId?: Id
}

export const getRequestableProductOption = (
  requestableProduct: RequestableProduct
): RequestableProductOptionType => ({
  label: requestableProduct.name,
  value: {
    label: requestableProduct.name,
    value: requestableProduct,
  },
  latinName: requestableProduct.latinName,
})

const useRequestableProductOptions = ({
  categoryId,
  verticalId,
}: RequestableProductOptionsProps = {}) => {
  const currentVertical = useCurrentVertical()
  const currentVerticalId = verticalId ?? currentVertical?.id

  const { data: requestableProducts, isInitialLoading } = useRecursiveRequestableProductsQuery({
    queryOptions: {
      staleTime: 0,
      enabled: !!currentVerticalId && !!categoryId,
    },
    queryParams: {
      ordering: 'name',
      categoryId,
      verticalId: currentVerticalId,
      withTemplate: false,
    },
  })

  const requestableProductOptions = useMemo(
    () => requestableProducts.map(getRequestableProductOption),
    [requestableProducts]
  )

  return { requestableProductOptions, isInitialLoading }
}

export default useRequestableProductOptions
